import { AuditLogRecordType } from '../../interfaces/management/schema.interface';
import { EventMeta } from '../../interfaces/meta.interface';

import ThreatIntelligence from './ThreatIntelligence';
import ThreatIntelligenceUrl from './ThreatIntelligenceUrl';

const records: Partial<{ [key in AuditLogRecordType]: { [key: string]: EventMeta<any> } }> = {
    [AuditLogRecordType.ThreatIntelligence]: ThreatIntelligence,
    [AuditLogRecordType.ThreatIntelligenceUrl]: ThreatIntelligenceUrl,
};

export default records;
